import { SerializableObject } from '../../core';

export enum ReportArgumentType {
  AccountNumber,
  Period,
  CalculationExpression,
  Text,
  Number,
}

export class ReportArgumentInfo extends SerializableObject {
  /**
   * Key for this argument.
   */
  Key: string;

  /**
   * The argument's default value.
   */
  DefaultValue: string;

  /**
   * The label/description for this argument.
   */
  Label: string;

  /**
   * The type of argument.
   */
  ArgumentType: ReportArgumentType;
}
